<template>
  <div class="oms-drag-wrapper" v-draggable="dragConfig" :style="{ left: position.x + 'px', top: position.y + 'px' }">
    <slot></slot>
    <!-- 包裹用户自定义内容 -->
  </div>
</template>

<script>
export default {
  name: 'OmsDrag',
  props: {
    // 是否启用拖拽（默认启用）
    enabled: { type: Boolean, default: true },
    // 初始位置 { x: number, y: number }
    initialPosition: { type: Object, default: () => ({ x: 0, y: 0 }) },
    // 边界限制：'parent'（父容器）/'window'（视窗）/'none'（无限制）
    boundary: { type: String, default: 'window' },
  },
  data() {
    return {
      position: { ...this.initialPosition },
      dragConfig: {
        enabled: this.enabled,
        boundary: this.boundary,
        onDrag: (newPos) => (this.position = newPos), // 更新位置
      },
    };
  },
  watch: {
    enabled(newVal) {
      this.dragConfig.enabled = newVal; // 动态启用/禁用拖拽
    },
  },
  directives: {
    // 自定义拖拽指令
    draggable: {
      bind(el, binding) {
        const { enabled, boundary, onDrag } = binding.value;
        if (!enabled) return;

        let startX,
          startY,
          initialX = 0,
          initialY = 0;
        let isDragging = false;

        // 计算边界范围
        const getBoundary = () => {
          if (boundary === 'parent') {
            const parentRect = el.parentNode.getBoundingClientRect();
            return {
              minX: 0,
              maxX: parentRect.width - el.offsetWidth,
              minY: 0,
              maxY: parentRect.height - el.offsetHeight,
            };
          } else {
            // 默认视窗边界
            return {
              minX: 0,
              maxX: window.innerWidth - el.offsetWidth,
              minY: 0,
              maxY: window.innerHeight - el.offsetHeight,
            };
          }
        };

        // 鼠标按下事件
        el.addEventListener('mousedown', (e) => {
          isDragging = true;
          startX = e.clientX;
          startY = e.clientY;
          initialX = el.offsetLeft;
          initialY = el.offsetTop;
          el.style.cursor = 'grabbing';
          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        });

        // 鼠标移动事件（节流优化）
        const onMouseMove = (e) => {
          if (!isDragging) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          let newX = initialX + dx;
          let newY = initialY + dy;

          // 边界处理 [6,7](@ref)
          const bounds = getBoundary();
          newX = Math.max(bounds.minX, Math.min(newX, bounds.maxX));
          newY = Math.max(bounds.minY, Math.min(newY, bounds.maxY));

          // 更新位置
          onDrag({ x: newX, y: newY });
        };

        // 鼠标释放事件
        const onMouseUp = () => {
          isDragging = false;
          el.style.cursor = 'grab';
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
        };
      },
    },
  },
};
</script>

<style scoped>
.oms-drag-wrapper {
  position: absolute;
  cursor: grab;
  user-select: none;
  z-index: 1000;
}
.oms-drag-wrapper:active {
  cursor: grabbing;
}
</style>
